import LinkedIn from "@/assets/LinkedIn.svg";
import Facebook from "@/assets/Facebook.svg";
// import Twitter from "@/assets/twitter_logo.svg";
import Instagram from "@/assets/Instagram.svg";

export const socials = [
  {
    label: "LinkedIn",
    url: "https://www.linkedin.com/company/gravitas-recruitment-group-global",
    icon: <LinkedIn />,
  },
  {
    label: "Facebook",
    url: "https://www.facebook.com/gravitasrecruitmentgroup",
    icon: <Facebook />,
  },
  // {
  //   label: "Twitter",
  //   url: "https://twitter.com/GravitasJobs",
  //   icon: <Twitter />,
  // },
  {
    label: "Instagram",
    url: "https://www.instagram.com/gravitasrecruitmentgroup",
    icon: <Instagram />,
  },
];
